"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HugeAsteroidRebalanced = void 0;
var PreludeCard_1 = require("../../prelude/PreludeCard");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var SelectHowToPayDeferred_1 = require("../../../deferredActions/SelectHowToPayDeferred");
var HugeAsteroidRebalanced = (function (_super) {
    __extends(HugeAsteroidRebalanced, _super);
    function HugeAsteroidRebalanced() {
        return _super.call(this, {
            name: CardName_1.CardName.HUGE_ASTEROID_REBALANCED,
            metadata: {
                cardNumber: 'P15',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.temperature(3).br;
                    b.megacredits(-2);
                }),
                description: 'Increase Temperature 3 steps. Pay 2 MC.',
            },
        }) || this;
    }
    HugeAsteroidRebalanced.prototype.play = function (player) {
        player.game.increaseTemperature(player, 3);
        player.game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, 2));
        return undefined;
    };
    return HugeAsteroidRebalanced;
}(PreludeCard_1.PreludeCard));
exports.HugeAsteroidRebalanced = HugeAsteroidRebalanced;
//# sourceMappingURL=HugeAsteroidRebalanced.js.map